// extracted by mini-css-extract-plugin
export default {"imageSection":"ImageSection_imageSection__sSKll","image":"ImageSection_image__woMYS","heading":"ImageSection_heading__UvI4n","subheading":"ImageSection_subheading__Lf4yj"};